import { assignPlanProgress, type AssignPlan } from "@edu/shared";

/**
 * Предложение продолжить брошенную раздачу (5.7 docs/homework-phase2-design.md).
 *
 * Согласие восстанавливает состояние формы вместе с ключами идемпотентности, то
 * есть повтор по уже созданным работам безопасен: сервер ответит теми же
 * работами, а не создаст вторые.
 *
 * ⚠️ В строке ИНИЦИАЛЫ, а не имена, и это не экономия места: в `localStorage`
 * полных имён нет вовсе (раздел 6 фазы 2). «А. Смирнова, Б. Ким» читается не
 * хуже, а хранилище перестаёт быть вторым списком учеников на устройстве.
 */

const dayFmt = new Intl.DateTimeFormat("ru-RU", { day: "numeric", month: "long" });

export function ResumeOffer(props: {
  plan: AssignPlan;
  onContinue: () => void;
  onDrop: () => void;
}) {
  const { created, total } = assignPlanProgress(props.plan);
  return (
    <section className="card assign__resume">
      <p>
        Домашка от {dayFmt.format(new Date(props.plan.createdAt))} задана не всем: {created} из{" "}
        {total}.
      </p>
      <p className="muted">{props.plan.students.map((s) => s.initials).join(", ")}</p>
      <div className="acts">
        <button type="button" className="btn" onClick={props.onContinue}>
          Продолжить
        </button>
        {/* Отказ от предложения, а не второе равноправное действие: тише */}
        <button type="button" className="btn btn--quiet" onClick={props.onDrop}>
          Начать заново
        </button>
      </div>
    </section>
  );
}
